import React, { useState, useEffect, useContext } from 'react'
import classes from './confirm.module.css'
import Axios from '../../../../../../Axios'
import { Urls } from '../../../../../../Urls'
import Loader from '../../../../../Loader'
import { Suggestion, next_page } from '../../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/Utility'
import Select from 'react-select/creatable'
import { toast } from 'react-toastify'
import { Activity, currentRequestTimeStamp } from '../../../../../../Constants'
import mixpanel from 'mixpanel-browser'
import { UserApiContext } from '../../../../../UserDetailsContext/UserDetailsContext'

const Confirm = ({
    step = 4,
    setStep = '',
    PreviosStep = 3,
    setPreviosStep = '',
    fetch_saved_details = '',
    excel_details = {},
    setDetails = '',
    onClose = ""
}) => {

    const [show, setshow] = useState(false)
    const [lane_details, setlane_details] = useState([])
    const [truckTypes, setTruckTypes] = useState([])
    const { userDetails } = useContext(UserApiContext);

    useEffect(() => {
        getTruckTypes()
        Axios.post(`${Urls.freight_master}?action=read_excel_file`, { "file_url": excel_details.blob_url })
            .then((response) => {
                // console.log(response.data, 'read_excel_file')
                setshow(true)
                Axios.post(`${Urls.freight_master}?action=get_saved_data`, { "excel_id": excel_details.excel_id })
                    .then(async (res) => {
                        // console.log(res.data, 'get_saved_data')
                        if (response.data.length > 0) {
                            var lanedetails = []
                            for (var i = 0; i < response?.data?.length; i++) {
                                // var origin = await getOrigin(res.data.unique_df, res.data.multistate, res.data.not_found_new, response.data[i])
                                // var destination = await getDestination(res.data.unique_df, res.data.multistate, res.data.not_found_new, response.data[i])
                                // var truck_type = await getTruckDetails(res.data.trk_matched, res.data.trk_spell, response.data[i], i)
                                // // console.log(origin, destination, truck_type)
                                var details = {
                                    raw_origin: response.data[i]['Origin Name*'] ? response.data[i]['Origin Name*'] : '',
                                    raw_destination: response.data[i]['Destination Name*'] ? response.data[i]['Destination Name*'] : '',
                                    origin: await getOrigin(res.data.unique_df, res.data.multistate, res.data.not_found_new, res.data.no_spellsugg, response.data[i]),
                                    destination: await getDestination(res.data.unique_df, res.data.multistate, res.data.not_found_new, res.data.no_spellsugg, response.data[i]),
                                    truck_type: await getTruckDetails(res.data.trk_matched, res.data.trk_spell, response.data[i], i)
                                }
                                // var details = {
                                //     "RAW ORIGIN": response.data[i]['Origin Name*'] ? response.data[i]['Origin Name*'] : '',
                                //     "ORIGIN NAME": origin.location.location ? origin.location.location : '',
                                //     "ORIGIN DISTRICT": origin.location.district ? origin.location.district : '',
                                //     "ORIGIN STATE": origin.location.state ? origin.location.state : '',
                                //     "ORIGIN LATITUDE": origin.location.lat ? origin.location.lat : '',
                                //     "ORIGIN LONGITUDE": origin.location.lon ? origin.location.lon : '',
                                //     "RAW DESTINATION": response.data[i]['Destination Name*'] ? response.data[i]['Destination Name*'] : '',
                                //     "DESTINATION NAME": destination.location.location ? destination.location.location : '' ,
                                //     "DESTINATION DISTRICT": destination.location.district ? destination.location.district : '',
                                //     "DESTINATION STATE": destination.location.state ? destination.location.state: '',
                                //     "DESTINATION LATITUDE": destination.location.lat ? destination.location.lat : '',
                                //     "DESTINATION LONGITUDE": destination.location.lon ? destination.location.lon : '',
                                //     "CONSOLIDATED TRUCK TYPE": truck_type.value ? truck_type.value : '',
                                //     "Median Rate": null,
                                //     "Maximum Rate": null,
                                //     "# Transporters": null,
                                //     // // "volume": response.data[i]['Annual Volume*'],
                                //     // "transit_time": response.data[i]['Transit Time (Days)'],
                                //     // "baseline_rate": 0,
                                //     // "transporter_details": await getTransporter(res.data.ven_matched, res.data.ven_spell, response.data[i])
                                // }
                                if (!get_lane_present(lanedetails, details)) {
                                    lanedetails.push(details)
                                }
                                if (i === response.data.length - 1) {
                                    setlane_details(lanedetails)
                                }
                            }
                        }
                        setshow(false)
                    })
            })
            .catch(e => {
                console.log(e)
                setshow(false)
            })
    }, [excel_details])

    const get_lane_present = (lanes, lane) => {
        for (var i = 0; i < lanes?.length; i++) {
            if (lanes[i]?.origin?.location_name === lane?.origin?.location_name
                && lanes[i]?.destination?.location_name === lane?.destination?.location_name
                && lanes[i]?.truck_type?.label === lane?.truck_type?.label) {
                return true
            }
        }
        return false
    }

    const getOrigin = async (unique_df, multistate, not_found_new, no_spellsugg, details) => {
        var origin = {}
        // console.log(details['Origin Name*'], details['Origin State*'])
        for (var i = 0; i < unique_df.length; i++) {
            if (unique_df[i]['Raw Location'] === details['Origin Name*'] && unique_df[i]['Raw State'] === details['Origin State*']) {
                origin = unique_df[i]['main_location']
                break
            }
        }
        for (var j = 0; j < multistate.length; j++) {
            if (multistate[j]['Raw Location'] === details['Origin Name*'] && multistate[j]['Raw State'] === details['Origin State*']) {
                origin = multistate[j]['main_location']
                break
            }
        }
        for (var k = 0; k < not_found_new.length; k++) {
            if (not_found_new[k]['Raw Location'] === details['Origin Name*'] && not_found_new[k]['Raw State'] === details['Origin State*']) {
                origin = not_found_new[k]['main_location']
                break
            }
        }
        for (var l = 0; l < no_spellsugg.length; l++) {
            if (no_spellsugg[l]['Raw Location'] === details['Origin Name*'] && no_spellsugg[l]['Raw State'] === details['Origin State*']) {
                origin = no_spellsugg[l]['main_location']
                break
            }
        }
        // console.log(origin)
        return origin
    }

    const getDestination = async (unique_df, multistate, not_found_new, no_spellsugg, details) => {
        var destination = {}
        for (var m = 0; m < unique_df.length; m++) {
            if (unique_df[m]['Raw Location'] === details['Destination Name*'] && unique_df[m]['Raw State'] === details['Destination State*']) {
                destination = unique_df[m]['main_location']
                break
            }
        }
        for (var n = 0; n < multistate.length; n++) {
            if (multistate[n]['Raw Location'] === details['Destination Name*'] && multistate[n]['Raw State'] === details['Destination State*']) {
                destination = multistate[n]['main_location']
                break
            }
        }
        for (var o = 0; o < not_found_new.length; o++) {
            if (not_found_new[o]['Raw Location'] === details['Destination Name*'] && not_found_new[o]['Raw State'] === details['Destination State*']) {
                destination = not_found_new[o]['main_location']
                break
            }
        }
        for (var p = 0; p < no_spellsugg.length; p++) {
            if (no_spellsugg[p]['Raw Location'] === details['Destination Name*'] && no_spellsugg[p]['Raw State'] === details['Destination State*']) {
                destination = no_spellsugg[p]['main_location']
                break
            }
        }
        return destination
    }

    const getTruckDetails = async (trk_matched, trk_spell, details) => {
        var truck = {}
        for (var i = 0; i < trk_matched.length; i++) {
            if (details['Truck Type*'] === trk_matched[i]['Truck']) {
                truck = {
                    label: trk_matched[i]['label'],
                    value: trk_matched[i]['value']
                }
                break
            }
        }
        for (var j = 0; j < trk_spell.length; j++) {
            if (details['Truck Type*'] === trk_spell[j]['Truck']) {
                truck = {
                    label: trk_spell[j]['label'],
                    value: trk_spell[j]['value']
                }
                break
            }
        }
        return truck
    }

    const getTruckTypes = () => {
        setshow(true)
        Axios.get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck`)
            .then(res => {
                var temp = []
                for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].network_truck_type_group) {
                        if (temp.filter(truck => truck.label === res.data[i].network_truck_type_group).length === 0) {
                            temp.push({ label: res.data[i].network_truck_type_group, value: res.data[i].network_truck_type_group })
                        }
                    }
                }
                setTruckTypes(temp)
                setshow(false)
                // console.log(truckTypes)
            })
            .catch(err => { setshow(false) })
    }

    const onChangeTruckType = (e, lane, index) => {
        var temp = lane_details.map((l, i) => {
            if (i === index) {
                l['truck_type'] = e
            }
            return l
        })
        setlane_details(temp)
    }

    // const changeHandler = (value, key, index) => {
    //     var temp = lane_details.map((l, i) => {
    //         if(i === index){
    //             l[key] = value
    //         }
    //         return l
    //     })
    //     setlane_details(temp)
    // }


    const validate = (lanes) => {
        for (var i = 0; i < lanes.length; i++) {
            // if(getbusinessshare(lanes[i].transporter_details)){
            //     toast.info('Please update your business share as 100%')
            //     return false
            // }
            if (!lanes[i].origin || lanes[i].origin === null) {
                toast.info('Please add origin')
                return false
            }
            if (!lanes[i].destination || lanes[i].destination === null) {
                toast.info('Please add destination')
                return false
            }
        }
        return true
    }

    const saveandconfirm = () => {
        Activity([{ "screen": "Company Profile", "module": "Freight Master Upload Excel", "user_activity": `Review and Confirm Screen: User clicked on Confirm Button`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`Benchmark Review and Confirm Screen: User clicked on Confirm Button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-CompanyProfile',
            ModuleName: 'edit_page',
            ActivityLog: `ReviewAndConfirmScreenUserClickedOnConfirmButton`,
            Data: `None`,
            Definition: `Benchmark Review and Confirm Screen: User clicked on Confirm Button`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
        if (validate(lane_details)) {
            var payload = {
                "cleaned_data": lane_details.map((lane) => {
                    return {
                        "RAW ORIGIN": lane.raw_origin,
                        "ORIGIN NAME": lane.origin.location.location ? lane.origin.location.location : '',
                        "ORIGIN DISTRICT": lane.origin.location.district ? lane.origin.location.district : '',
                        "ORIGIN STATE": lane.origin.location.state ? lane.origin.location.state : '',
                        "ORIGIN LATITUDE": lane.origin.location.lat ? lane.origin.location.lat : '',
                        "ORIGIN LONGITUDE": lane.origin.location.lon ? lane.origin.location.lon : '',
                        "RAW DESTINATION": lane.raw_destination,
                        "DESTINATION NAME": lane.destination.location.location ? lane.destination.location.location : '',
                        "DESTINATION DISTRICT": lane.destination.location.district ? lane.destination.location.district : '',
                        "DESTINATION STATE": lane.destination.location.state ? lane.destination.location.state : '',
                        "DESTINATION LATITUDE": lane.destination.location.lat ? lane.destination.location.lat : '',
                        "DESTINATION LONGITUDE": lane.destination.location.lon ? lane.destination.location.lon : '',
                        "CONSOLIDATED TRUCK TYPE": lane.truck_type.value ? lane.truck_type.value : '',
                        "Median Rate": null,
                        "Maximum Rate": null,
                        "# Transporters": null,
                    }
                }),
                "blob_uri": excel_details.blob_url,
                "excel_id": excel_details.excel_id
            }
            // console.log(payload)
            setshow(true)
            Axios.post(`${Urls.benchmarnow}?field=store_in_blob`, payload)
                .then(res => {
                    toast.success('Lanes Uploaded Sucessfully. Click on View Uploaded Lanes to get the rates.')
                    // console.log(res.data)
                    next_page({ "data": "completed", "excel_id": excel_details.excel_id, "key": "page" })
                    // next_page({"data":false,"excel_id":excel_details.excel_id,"key":"benchmark_seen"})
                    document.getElementById("close_contactus1").click()
                    onClose()
                    setshow(false)
                    // window.location.reload()
                })
                .catch(e => {
                    console.log(e);
                    setshow(false)
                })
        }
    }

    const previous = () => {
        setStep(3)
    }

    const cancelProcess = () => {
        if (window.confirm("Are you sure to cancel?")) {
            next_page({ "data": "completed", "excel_id": excel_details.excel_id, "key": "page" }) //Imp
            document.getElementById("close_contactus1").click()
            toast.success('Process Cancelled Successfully')
        }
    }

    return (
        <center>
            <Loader show={show} />
            <div style={{ border: '1px solid grey', padding: '1%', marginTop: '4%' }}>
                <div className={`${classes['lanestable']}`}>
                    <div className={`${classes["headers"]}`}>
                        {/* <div className={classes['origin']}>Raw Origin</div> */}
                        <div className={classes['origin']}>Origin</div>
                        <div className={classes['origin_state']}>Origin State</div>
                        {/* <div className={classes['destination']}>Raw Destination</div> */}
                        <div className={classes['destination']}>Destination</div>
                        <div className={classes['destination_state']}>Destination State</div>
                        <div className={classes['truck_type']}>Truck Type</div>
                    </div>
                    <div className={classes['lane_details']}>
                        {lane_details.map((lane, index) => {
                            return <div className={`${classes["lanes"]}`}>
                                {/* <div className={classes['origin']}>{lane_details.raw_origin ? lane_details.raw_origin : ''}</div> */}
                                <div className={classes['origin']}>
                                    <Suggestion
                                        value={lane.origin}
                                        onSelect={(e) => {
                                            var temp = lane_details.map((l, i) => {
                                                // console.log(l)
                                                if (i === index) {
                                                    l['origin'] = e
                                                }
                                                return l
                                            })
                                            setlane_details(temp)
                                        }}
                                        showlocation={true}
                                    />
                                </div>
                                <div className={classes['origin_state']}>{lane.origin && lane.origin.location ? lane.origin.location.state : ''}</div>
                                {/* <div className={classes['destination']}>{lane_details.raw_destination ? lane_details.raw_destination : ''}</div> */}
                                <div className={classes['destination']}>
                                    <Suggestion
                                        placeholder={"Destination"}
                                        value={lane.destination}
                                        onSelect={(e) => {
                                            var temp = lane_details.map((l, i) => {
                                                if (i === index) {
                                                    l['destination'] = e
                                                }
                                                return l
                                            })
                                            setlane_details(temp)
                                        }}
                                        showlocation={true}
                                    />
                                </div>
                                <div className={classes['destination_state']}>{lane.destination && lane.destination.location ? lane.destination.location.state : ''}</div>
                                <div className={classes['truck_type']}>{lane.truck_type ?
                                    <Select
                                        options={truckTypes}
                                        isMulti={false}
                                        onChange={value => onChangeTruckType(value, lane, index)}
                                        className={"Truck_Type_Select"}
                                        classNamePrefix={"Truck_Prefix"}
                                        defaultValue={lane.truck_type}
                                    />
                                    : null}</div>

                            </div>

                        })}
                    </div>
                </div>
                <div className={classes['button-bar']}>
                    <button className='btn btn-sm btn-danger mr-3' onClick={e => cancelProcess()}>Cancel</button>
                    <button className={`btn btn-sm btn-primary`} style={{ marginRight: '3%' }} disabled={show} onClick={e => previous()}>Previous</button>
                    <button className={`btn btn-sm btn-success`} disabled={show} onClick={e => saveandconfirm()}>Confirm</button>
                </div>
            </div>
        </center>
    )
}

export default Confirm
